import { render } from "./NewItemModal.vue?vue&type=template&id=3152adb3"
import script from "./NewItemModal.vue?vue&type=script&lang=js"
export * from "./NewItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__